const pageCart = document.querySelector('.woocommerce-cart');

if (pageCart) {
  const cartIconContainer = document.querySelector('.cart_header');

  if (cartIconContainer) {
    const cartBadge = cartIconContainer.querySelector('.badge');

    document.body.addEventListener('novada_updated_wc_div', (e) => {
      updateCart()
    })

    const updateCart = () => {
      const cartItems = document.querySelectorAll('.woocommerce-cart-form .shop_table tbody .cart_item');
      cartBadge.textContent = cartItems.length;
      if (cartItems.length === 0) {
        cartIconContainer.style.display = 'none';
      } else {
        cartIconContainer.style.display = 'grid';
      }
    }
  }
}
